// Sentry must initialize before anything else so it catches errors
// during render/mount of the rest of the app.
import "./sentry";
import "./amplify";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Sentry } from "./sentry";
import App from "./App";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-faint">
              error
            </div>
            <h1 className="mt-3 font-serif text-3xl">Something broke.</h1>
            <p className="mt-2 font-serif italic text-ink-soft text-base">
              The error has been logged. You can try reloading.
            </p>
            <pre className="mt-4 font-mono text-[11px] text-ink-faint max-w-full overflow-x-auto">
              {(error as Error)?.message ?? String(error)}
            </pre>
            <button
              onClick={resetError}
              className="mt-5 rounded-md bg-terracotta text-paper px-4 py-2 text-[13px] hover:bg-terracotta-soft"
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
